(function () {
    'use strict';

    angular.module("imApp").factory("consignmentColliDetailService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1427,
                    parameters: parms || {}
                });
            },
            listDetails: function (parms) {
                return $ihttp.post({
                    method: 2654,
                    parameters: parms || {}
                });
            },
            saveObj: function (mergeObj) {
                return $ihttp.post({
                    method: 1429,
                    parameters: mergeObj
                });
            }
        };

        return service;
    }]);
})();
